import { ledgerApi } from '../../../api';
import type { ManualPaymentInput, LedgerEntry } from '../../../types';
import type { GameStateGetter } from '../types';

export const createRecordPayment = (get: GameStateGetter) => {
  return async (boardId: string, input: ManualPaymentInput): Promise<LedgerEntry> => {
    const entry = await ledgerApi.recordPayment(boardId, input);
    await get().fetchLedger(boardId);
    return entry;
  };
};
